import { Box, Container, Breadcrumbs, Link, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { NavigateNext } from "@mui/icons-material";
import { ItemIssueReturnForm } from "../../components/ItemIssueReturn/ItemIssueReturnForm";

export const InvCreateReturnPage = () => {
  return (
    <Container maxWidth="xl">
      <Box sx={{ mb: 3 }}>
        <Breadcrumbs
          separator={<NavigateNext fontSize="small" />}
          aria-label="breadcrumb"
          sx={{ mb: 2 }}
        >
          <Link
            component={RouterLink}
            to="/dashboard"
            underline="hover"
            color="inherit"
          >
            Dashboard
          </Link>
          <Link
            component={RouterLink}
            to="/item-issue-returns"
            underline="hover"
            color="inherit"
          >
            Item Issue Returns
          </Link>
          <Typography color="text.primary">New Return</Typography>
        </Breadcrumbs>
      </Box>

      <ItemIssueReturnForm />
    </Container>
  );
};
